module.exports = __webpack_public_path__ + "img/pen.57f720a5.svg";